"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IDL = void 0;
exports.IDL = {
    "version": "0.1.0",
    "name": "liquidity_gauges",
    "instructions": [
        {
            "name": "initializeLiquidityGaugemeister",
            "accounts": [
                {
                    "name": "liquidityGaugemeister",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "gaugemeister",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "foreman",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "realm",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "admin",
                    "isMut": false,
                    "isSigner": true
                },
                {
                    "name": "rewarder",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "quarryOperator",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "quarryAdmin",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "shareAllocator",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "rentPayer",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "escrowRelockerProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "quarryOperatorProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "nextEpochStart",
                    "type": "i64"
                },
                {
                    "name": "epochLength",
                    "type": "i64"
                }
            ]
        },
        {
            "name": "createLiquidityGauge",
            "accounts": [
                {
                    "name": "liquidityGaugemeister",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "gaugemeister",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "foreman",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "rewarder",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "quarry",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "gauge",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "rentPayer",
                    "isMut": true,
                    "isSigner": true
                },
                {
                    "name": "systemProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "escrowRelockerProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": []
        },
        {
            "name": "updateGaugeSnapshot",
            "accounts": [
                {
                    "name": "liquidityGaugemeister",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "gaugemeister",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "foreman",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "gauge",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "escrowRelockerProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": []
        },
        {
            "name": "updateQuarry",
            "accounts": [
                {
                    "name": "liquidityGaugemeister",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "gaugemeister",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "foreman",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "gauge",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "quarry",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "rewarder",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "quarryOperator",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "shareAllocator",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "escrowRelockerProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "quarryMineProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "quarryOperatorProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": []
        },
        {
            "name": "setupNewEpoch",
            "accounts": [
                {
                    "name": "liquidityGaugemeister",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "gaugemeister",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "foreman",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "escrowRelockerProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": []
        },
        {
            "name": "setEpochLength",
            "accounts": [
                {
                    "name": "liquidityGaugemeister",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "gaugemeister",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "realm",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "admin",
                    "isMut": false,
                    "isSigner": true
                }
            ],
            "args": [
                {
                    "name": "epochLength",
                    "type": "i64"
                }
            ]
        },
        {
            "name": "gaugeEnable",
            "accounts": [
                {
                    "name": "liquidityGaugemeister",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "gaugemeister",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "realm",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "foreman",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "admin",
                    "isMut": false,
                    "isSigner": true
                },
                {
                    "name": "gauge",
                    "isMut": true,
                    "isSigner": false,
                    "docs": [
                        "The [Gauge] to enable."
                    ]
                },
                {
                    "name": "escrowRelockerProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": []
        },
        {
            "name": "gaugeDisable",
            "accounts": [
                {
                    "name": "liquidityGaugemeister",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "gaugemeister",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "realm",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "foreman",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "admin",
                    "isMut": false,
                    "isSigner": true
                },
                {
                    "name": "gauge",
                    "isMut": true,
                    "isSigner": false,
                    "docs": [
                        "The [Gauge] to enable."
                    ]
                },
                {
                    "name": "escrowRelockerProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": []
        },
        {
            "name": "forcedCloseLiquidityVote",
            "accounts": [
                {
                    "name": "gaugeVote",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "escrow",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "nftToken",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "rentCollector",
                    "isMut": true,
                    "isSigner": false,
                    "docs": [
                        "just to be 100% sure it is closeable in any case"
                    ]
                },
                {
                    "name": "gaugeVoter",
                    "isMut": true,
                    "isSigner": false,
                    "docs": [
                        "Gauge voter."
                    ]
                },
                {
                    "name": "liquidityGaugemeister",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "gaugemeister",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "realm",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "foreman",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "admin",
                    "isMut": false,
                    "isSigner": true
                },
                {
                    "name": "gauge",
                    "isMut": true,
                    "isSigner": false,
                    "docs": [
                        "Gauge."
                    ]
                },
                {
                    "name": "escrowRelockerProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": []
        },
        {
            "name": "setOperatorRateSetter",
            "accounts": [
                {
                    "name": "liquidityGaugemeister",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "gaugemeister",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "realm",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "foreman",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "admin",
                    "isMut": false,
                    "isSigner": true
                },
                {
                    "name": "rewarder",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "quarryOperator",
                    "isMut": true,
                    "isSigner": false,
                    "docs": [
                        "The [Operator] of the [Rewarder]."
                    ]
                },
                {
                    "name": "quarryAdmin",
                    "isMut": false,
                    "isSigner": false,
                    "docs": [
                        "The [Operator::admin]."
                    ]
                },
                {
                    "name": "delegate",
                    "isMut": false,
                    "isSigner": false,
                    "docs": [
                        "The account to give the role to."
                    ]
                },
                {
                    "name": "quarryOperatorProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": []
        },
        {
            "name": "setOperatorQuarryCreator",
            "accounts": [
                {
                    "name": "liquidityGaugemeister",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "gaugemeister",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "realm",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "foreman",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "admin",
                    "isMut": false,
                    "isSigner": true
                },
                {
                    "name": "rewarder",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "quarryOperator",
                    "isMut": true,
                    "isSigner": false,
                    "docs": [
                        "The [Operator] of the [Rewarder]."
                    ]
                },
                {
                    "name": "quarryAdmin",
                    "isMut": false,
                    "isSigner": false,
                    "docs": [
                        "The [Operator::admin]."
                    ]
                },
                {
                    "name": "delegate",
                    "isMut": false,
                    "isSigner": false,
                    "docs": [
                        "The account to give the role to."
                    ]
                },
                {
                    "name": "quarryOperatorProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": []
        },
        {
            "name": "closeLiquidityGaugemeister",
            "accounts": [
                {
                    "name": "liquidityGaugemeister",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "gaugemeister",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "foreman",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "realm",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "admin",
                    "isMut": false,
                    "isSigner": true
                },
                {
                    "name": "rewarder",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "quarryOperator",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "quarryAdmin",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "newQuarryAdmin",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "rentCollector",
                    "isMut": true,
                    "isSigner": false
                },
                {
                    "name": "escrowRelockerProgram",
                    "isMut": false,
                    "isSigner": false
                },
                {
                    "name": "quarryOperatorProgram",
                    "isMut": false,
                    "isSigner": false
                }
            ],
            "args": [
                {
                    "name": "newForeman",
                    "type": "publicKey"
                }
            ]
        }
    ],
    "accounts": [
        {
            "name": "liquidityGaugemeister",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "gaugemeister",
                        "type": "publicKey"
                    },
                    {
                        "name": "rewarder",
                        "type": "publicKey"
                    },
                    {
                        "name": "epochLength",
                        "type": "i64"
                    },
                    {
                        "name": "gaugeSnapshotsUpdated",
                        "type": "u64"
                    },
                    {
                        "name": "quarriesUpdated",
                        "type": "u64"
                    },
                    {
                        "name": "foremanBump",
                        "type": "u8"
                    },
                    {
                        "name": "shareAllocatorBump",
                        "type": "u8"
                    },
                    {
                        "name": "quarryAdminBump",
                        "type": "u8"
                    }
                ]
            }
        }
    ],
    "types": [
        {
            "name": "GaugeInfo",
            "type": {
                "kind": "struct",
                "fields": [
                    {
                        "name": "quarry",
                        "type": "publicKey"
                    },
                    {
                        "name": "lastUpdateEpochStartTime",
                        "type": "i64"
                    }
                ]
            }
        }
    ],
    "errors": [
        {
            "code": 6000,
            "name": "CalculationError",
            "msg": "Calculation error"
        },
        {
            "code": 6001,
            "name": "InitializingActiveRewarder",
            "msg": "Initializing active rewarder"
        },
        {
            "code": 6002,
            "name": "NextEpochStartMustBeInFuture",
            "msg": "Next epoch start must be in future"
        },
        {
            "code": 6003,
            "name": "EpochLengthMustBePositive",
            "msg": "Epoch length must be positive"
        },
        {
            "code": 6004,
            "name": "InvalidGaugemeisterForeman",
            "msg": "Invalid gaugemeister foreman"
        },
        {
            "code": 6005,
            "name": "InvalidShareAlocator",
            "msg": "Invalid share allocator"
        },
        {
            "code": 6006,
            "name": "NextEpochStartWasNotUpdated",
            "msg": "Next epoch start was not updated"
        },
        {
            "code": 6007,
            "name": "GaugeSnapshotIsAlreadyUpdated",
            "msg": "Gauge snapshot ise already updated"
        },
        {
            "code": 6008,
            "name": "TooEarlyToUpdateQuarries",
            "msg": "Too early to update quarries"
        },
        {
            "code": 6009,
            "name": "IvalidQuarry",
            "msg": "Invalid quarry"
        },
        {
            "code": 6010,
            "name": "TooEarlyToSetupNewEpoch",
            "msg": "Too early to setup new epoch"
        },
        {
            "code": 6011,
            "name": "QuarryWasUpdatedTwice",
            "msg": "Quarry was updated twice"
        },
        {
            "code": 6012,
            "name": "MustFinishQuarryUpdateBeforeEpochChange",
            "msg": "Must finish quarry update before epoch change"
        },
        {
            "code": 6013,
            "name": "InvalidRealm",
            "msg": "Invalid realm"
        },
        {
            "code": 6014,
            "name": "InvalidForeman",
            "msg": "Invalid foreman"
        },
        {
            "code": 6015,
            "name": "GaugemeisterMustBeEmptyToBecomeLiquidityOne",
            "msg": "Gaugemeister must be empty to become liquidity one"
        },
        {
            "code": 6016,
            "name": "InvalidQuarryOperatorAdmin",
            "msg": "Invalid quarry operator admin"
        },
        {
            "code": 6017,
            "name": "GaugeSnapshotsAreNotUpdated",
            "msg": "Gauge snapshots are not updated"
        }
    ]
};
//# sourceMappingURL=liquidity_gauges.js.map